import { IMail, IMailroom } from '@commenda/api';
import { Badge } from '@commenda/kakashi';
import { cn, NonTimezoneSensitiveDate } from '@commenda/utils';
import { transformToTitleCase } from '@commenda/utils/transformString';
import { MailroomType } from '@prisma/client';
import { useState } from 'react';

const MailCard = ({
  mail,
  selectedMailId,
  setSelectedMailId,
}: {
  mail: IMail & { mailroom: IMailroom };
  selectedMailId: string;
  setSelectedMailId: (id: string) => void;
}) => {
  const [isRead, setIsRead] = useState(mail.isRead);
  return (
    <div
      key={mail.id}
      className={cn(
        'p-xl py-lg cursor-pointer transition-all duration-200 border-transparent border-border-primary border-l-0 border-r-0 border-t-0 border-b-2',
        selectedMailId === mail.id
          ? 'bg-bg-secondary border-border-primary border-l-8'
          : 'hover:bg-bg-secondary'
      )}
      onClick={() => {
        setSelectedMailId(mail.id);
        if (!isRead) setIsRead(true);
      }}
    >
      <div className="flex justify-between items-start gap-4">
        <div className="mr-4 mt-4 flex-shrink-0">
          {!isRead && <div className="w-3 h-3 bg-blue-500 rounded-full" />}
        </div>
        <div className="flex-1 min-w-0">
          <span className="text-xs text-text-tertiary">
            {NonTimezoneSensitiveDate.fromNativeDate(
              new Date(mail.createdAt)
            ).toReadableString()}
          </span>
          <h3 className="font-semibold text-base mb-1.5 mt-0.5 truncate">
            {mail.title}
          </h3>
          <div className="flex items-center gap-3">
            <Badge
              variant={
                mail.mailroom.mailroomType === MailroomType.REGISTERED_AGENT
                  ? 'blue'
                  : 'gray'
              }
            >
              {transformToTitleCase(mail.mailroom.mailroomType)}
            </Badge>
          </div>
        </div>
      </div>
    </div>
  );
};

export { MailCard };
